export enum ProviderActionEnum {
  Action = 0,
  Create,
  Append,
  Update,
  Patch,
  Delete,
  Load,
  LoadAll
}
